import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import accountArs from "./accountArs";
import accounts from "./accounts";
import agreements from "./agreements";
import alerts from "./alerts";
import auth from "./auth";
import billingDefinitions from "./billingDefinitions";
import billingGroups from "./billingGroups";
import cashReserves from "./cashReserves";
import clients from "./clients";
import companies from "./companies";
import criticalpaths from "./criticalpaths";
import criticalpathVersions from "./criticalpathVersions";
import custodialFormFields from "./custodialFormFields";
import custodialFormFunctions from "./custodialFormFunctions";
import custodialForms from "./custodialForms";
import custodialRequests from "./custodialRequests";
import grid from "./grid";
import household from "./household";
import households from "./households";
import householdTickets from "./householdTickets";
import incomeBuilderInventories from "./incomeBuilderInventories";
import incomeBuilders from "./incomeBuilders";
import layout from "./layout";
import leads from "./leads";
import models from "./models";
import monitors from "./monitors";
import proposalAccounts from "./proposalAccounts";
import proposalInventories from "./proposalInventories";
import proposals from "./proposals";
import proposalVersions from "./proposalVersions";
import roles from "./roles";
import securityRestrictions from "./securityRestrictions";
import serviceTeams from "./serviceTeams";
import sharedObjects from "./sharedObjects";
import tamaracReportFields from "./tamaracReportFields";
import tamaracReports from "./tamaracReports";
import tamaracTransactions from "./tamaracTransactions";
import tradeRequests from "./tradeRequests";
import types from "./types";
import users from "./users";
import watchers from "./watchers";
import wizard from "./wizard";

const makeRootReducer = (asyncReducers) => {
  return combineReducers({
    ...asyncReducers,
    users,
    auth,
    households,
    household,
    types,
    accounts,
    companies,
    grid,
    alerts,
    serviceTeams,
    models,
    roles,
    proposals,
    proposalAccounts,
    proposalVersions,
    proposalInventories,
    sharedObjects,
    criticalpaths,
    criticalpathVersions,
    agreements,
    securityRestrictions,
    billingDefinitions,
    billingGroups,
    accountArs,
    cashReserves,
    householdTickets,
    clients,
    custodialRequests,
    custodialForms,
    custodialFormFunctions,
    custodialFormFields,
    layout,
    tamaracTransactions,
    wizard,
    monitors,
    tradeRequests,
    watchers,
    leads,
    incomeBuilders,
    incomeBuilderInventories,
    tamaracReports,
    tamaracReportFields,
    form: formReducer,
  });
};

export default makeRootReducer;
